import React from 'react';
import { ActionButton } from '@adobe/react-spectrum';
import Refresh from '@spectrum-icons/workflow/Refresh';
import Close from '@spectrum-icons/workflow/Close';
import { useDispatch, useSelector } from 'react-redux';
import { aiAssistantActions } from '../../store/aiAssistantSlice';
import { selectIsStreaming } from '../../store/selectors';

interface ChatTopBarProps {
  onClose?: () => void;
}

export function ChatTopBar({ onClose }: ChatTopBarProps) {
  const dispatch = useDispatch();
  const isStreaming = useSelector(selectIsStreaming);

  return (
    <header className="rau-top-bar">
      <div className="rau-top-bar-actions">
        <ActionButton
          isQuiet
          isDisabled={isStreaming}
          onPress={() => dispatch(aiAssistantActions.newConversation())}
          aria-label="New conversation"
          UNSAFE_className="rau-top-bar-icon-btn"
        >
          <Refresh />
        </ActionButton>
        {onClose ? (
          <ActionButton
            isQuiet
            onPress={onClose}
            aria-label="Close"
            UNSAFE_className="rau-top-bar-icon-btn"
          >
            <Close />
          </ActionButton>
        ) : null}
      </div>
    </header>
  );
}
